<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>
        {{
          isUpdate
            ? `Cập nhật phiếu yêu cầu hoàn hàng ${billNumber}`
            : 'Thêm phiếu yêu cầu hoàn hàng'
        }}
      </h1>
      <div class="float-right btn-group">
        <button type="button" class="font-medium btn btn-outline-secondary" @click="requestItem()">
          <i class="bx bx-save"></i> {{ isUpdate ? 'Lưu' : 'Thêm' }}
        </button>
        <button
          type="button"
          class="font-medium btn btn-outline-secondary"
          @click="checkCloseAdd()"
        >
          <i class="bx bx-exit"></i> Quay lại
        </button>
      </div>
    </div>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <ValidationObserver ref="inventoryRef" class="px-20 mt-2 card-body row">
        <form class="col-md-12">
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="timeReturn" name="Ngày hoàn">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-4 col-form-label">
                    Ngày hoàn<span class="text-danger">*</span>
                  </label>
                  <div class="col-sm-8">
                    <datepicker
                      v-model="dataAdd.timeReturn"
                      :language="vi"
                      format="dd/MM/yyyy"
                      input-class="form-control"
                      placeholder="Chọn ngày hoàn"
                    ></datepicker>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="required" vid="reasonReturn" name="Lý do hoàn">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-4 col-form-label">
                    Lý do hoàn<span class="text-danger">*</span>
                  </label>
                  <div class="col-sm-8">
                    <Select2
                      v-model="dataAdd.reasonReturn"
                      :options="reasonReturnData"
                      placeholder="Chọn lý do hoàn"
                    >
                    </Select2>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </div>
                </div>
              </ValidationProvider>

              <ValidationProvider rules="maxReceipt_2" vid="description" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-4 col-form-label">Ghi chú</label>
                  <div class="col-sm-8">
                    <textarea
                      v-model="dataAdd.description"
                      class="form-control"
                      rows="3"
                      placeholder="Nhập ghi chú"
                      maxlength="255"
                    ></textarea>
                    <div class="text-right small text-muted mt-1">
                      {{ dataAdd.description ? dataAdd.description.length : 0 }}/255
                    </div>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>

      <div class="p-10 pt-2 card">
        <div
          class="mb-2 d-flex pos-relative w-100 justify-content-between align-items-baseline flex-wrap"
        >
          <h1 class="mb-1 form-inner-heading">Bảng thông tin thiết bị</h1>
          <div class="float-right btn-group">
            <button @click="openAddDevice" class="font-medium f12 btn btn-outline-secondary">
              <i class="bx bxs-plus-circle"></i> Thêm lẻ
            </button>
            <button @click="downloadFileTemplate" class="font-medium f12 btn btn-outline-secondary">
              <i class="bx bx-download"></i> Tải mẫu
            </button>
            <button
              @click="$refs.uploadFileExcel.click()"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-upload"></i> Nhập file
            </button>
            <button
              @click="deleteDeviceMul"
              v-if="selected.length > 0"
              class="font-medium f12 btn btn-outline-secondary"
            >
              <i class="bx bx-minus-circle"></i> Xoá
            </button>
            <input
              style="display: none"
              ref="uploadFileExcel"
              @change="uploadFileExcel"
              type="file"
              accept=".xls,.xlsx,.csv,.ods"
            />
          </div>
        </div>
        <div class="tab-content">
          <div class="table-responsive" style="overflow: auto; max-height: 70vh">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr class="text-center">
                  <th style="width: 50px">
                    <input type="checkbox" v-model="selectAll" />
                  </th>
                  <th>Serial thiết bị</th>
                  <th>Mã HĐ/PL</th>
                  <th>Ghi chú</th>
                  <th style="width: 100px">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="table-row"
                  v-for="(device, index) in dataAdd.orderDevices"
                  :key="`device${index}`"
                >
                  <td class="text-center">
                    <input type="checkbox" v-model="selected" :value="device" />
                  </td>
                  <td>{{ device.serial }}</td>
                  <td>{{ device.contractCode }}</td>
                  <td>{{ device.description || '' }}</td>
                  <td class="text-center">
                    <b-dropdown class="text-center" variant="outline-light">
                      <button class="dropdown-item" @click="openEditDevice(device, index)">
                        <i class="bx bx-pencil"></i>&nbsp; Sửa
                      </button>
                      <button class="dropdown-item" @click="deleteDevice(index)">
                        <i class="bx bx-minus-circle"></i>&nbsp; Xoá
                      </button>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="text-center modal-body">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="py-3 f18">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="closeAdd"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Bỏ qua
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <b-modal
      id="modal-noti"
      centered
      v-model="modalEditDevice"
      ignore-enforce-focus-selector="input"
    >
      <template #modal-header="{ close }">
        <h5>{{ modalEditDeviceStatus === 'add' ? 'Thêm' : 'Sửa' }} thiết bị</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <ValidationObserver ref="deviceRef" class="px-20 mt-2 card-body" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(requestDevice)">
          <ValidationProvider rules="required" vid="deviceSerial" name="Serial thiết bị">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label">
                Serial thiết bị <span class="text-danger">*</span>
              </label>
              <div class="col-sm-8">
                <SelectRemote
                  v-model="device.serial"
                  :options="devicesCanReturnData"
                  :remote="true"
                  :remote-method="searchDevices"
                  :loading="loadingDevices"
                  :enable-load-more="true"
                  :current-page="currentPage"
                  :has-more="hasMoreDevices"
                  placeholder="Nhập serial để tìm kiếm"
                  @change="onDeviceSelected"
                  @load-more="handleLoadMoreDevices"
                >
                </SelectRemote>
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" vid="contractCode" name="Mã HĐ/PL">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label">
                Mã HĐ/PL <span class="text-danger">*</span>
              </label>
              <div class="col-sm-8">
                <input
                  v-model.trim="device.contractCode"
                  type="text"
                  class="form-control"
                  placeholder="Nhập mã hợp đồng/phụ lục"
                />
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="maxReceipt_2" vid="deviceDescription" name="Ghi chú">
            <div class="form-group row" slot-scope="{ errors }">
              <label for class="col-sm-4 col-form-label">Ghi chú</label>
              <div class="col-sm-8">
                <textarea
                  v-model="device.description"
                  class="form-control"
                  rows="3"
                  placeholder="Nhập ghi chú"
                  maxlength="255"
                ></textarea>
                <div class="text-right small text-muted mt-1">
                  {{ device.description ? device.description.length : 0 }}/255
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </div>
          </ValidationProvider>
          <button type="submit" v-show="false" />
        </form>
      </ValidationObserver>
      <template #modal-footer="{ cancel }">
        <b-button @click="requestDevice" size="md" variant="primary">
          {{ modalEditDeviceStatus === 'add' ? 'Thêm' : 'Cập nhật' }}
        </b-button>
        <b-button size="md" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid'
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import cloneDeep from 'lodash/cloneDeep'
  import differenceBy from 'lodash/differenceBy'
  import SelectRemote from '@/components/common/SelectRemote.vue'

  export default {
    components: {
      SelectRemote,
    },
    data() {
      return {
        billNumber: '',
        isUpdate: false,
        dataAdd: {
          timeReturn: new Date(),
          reasonReturn: 'RETURN_E_COMMERCE',
          description: '',
          orderDevices: [],
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        showModalNoti: false,
        messNoti: '',
        srcImage: '',
        keyCheck: 'cancel',
        vi: vi,
        selected: [],
        reasonReturnData: [{ id: 'RETURN_E_COMMERCE', text: 'Hoàn hàng TMĐT' }],
        modalEditDevice: false,
        modalEditDeviceStatus: 'add',
        device: {},
        deviceIndex: 0,
        devicesCanReturnData: [],
        allDevicesCanReturn: {},
        loadingDevices: false,
        currentPage: 1,
        hasMoreDevices: false,
        totalDevices: 0,
        currentSearchQuery: '',
      }
    },

    created() {
      this.checkHasCoppy()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      selectAll: {
        get: function () {
          return this.dataAdd.orderDevices
            ? this.selected.length === this.dataAdd.orderDevices.length
            : false
        },
        set: function (value) {
          if (value) {
            this.selected = cloneDeep(this.dataAdd.orderDevices)
          } else this.selected = []
        },
      },
    },

    methods: {
      async checkHasCoppy() {
        if (this.$route.params.coppyFrom || this.$route.params.entryId) {
          if (this.$route.params.entryId) {
            this.isUpdate = true
          }
          this.loading = true
          const res = await DeviceService.detailReturnRequest(
            this.$route.params.coppyFrom ?? this.$route.params.entryId
          )
          if (res.code === 1000) {
            this.billNumber = res.data.billNumber
            const listCopy = {
              timeReturn: new Date(res.data.timeReturn),
              reasonReturn: res.data.reasonReturn,
              description: res.data.description || '',
              orderDevices: (res.data.devices || []).map(d => ({
                ...d,
                description: d.noteImport || '',
              })),
            }
            this.dataAdd = listCopy
          }
          this.loading = false
        }
      },

      async checkCloseAdd() {
        if (this.keyCheck) {
          this.showErr('Bạn có chắc chắn muốn huỷ bỏ thao tác không ?')
          this.keyCheck = 'back'
        }
        this.closeAdd()
      },

      async closeAdd() {
        this.$router.push('/return-request')
      },

      async requestItem() {
        const isSuccess = await this.$refs.inventoryRef.validate()
        if (!isSuccess) {
          this.keyCheck = 'cancel'
          return
        }
        if (this.dataAdd.orderDevices.length === 0) {
          this.showErr('Danh sách thiết bị không được bỏ trống')
          return
        }
        try {
          this.loading = true
          const params = cloneDeep(this.dataAdd)
          params.id = this.$route.params.entryId
          params.timeReturn = new Date(params.timeReturn).getTime()
          params.orderDevices = params.orderDevices.map(s => ({
            serial: s.serial,
            contractCode: s.contractCode,
            description: s.description || '',
          }))

          let response = {}
          if (this.isUpdate) {
            response = await DeviceService.updateReturnRequest(params)
          } else {
            response = await DeviceService.createReturnRequest(params)
          }

          if (response.code === 1000) {
            this.keyCheck = 'accept'
            this.showSuccess(
              this.isUpdate
                ? 'Cập nhật phiếu yêu cầu hoàn hàng thành công !'
                : 'Thêm phiếu yêu cầu hoàn hàng thành công !'
            )
          } else if (response.code === 1025 || response.code === 1039 || response.code === 1042) {
            this.keyCheck = 'addLead'
            this.showErr(response.message)
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          if (error.message) this.showErr(error.message)
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },
      showSuccess(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-success2.svg')
      },

      checkToActionModal(keyCheck) {
        if (keyCheck === 'accept' || keyCheck === 'back') {
          this.showModalNoti = false
          this.closeAdd()
        }
        if (keyCheck === 'addLead') {
          this.showModalNoti = false
          this.requestItem()
        }
      },

      searchDevices(query, page = 1, callback) {
        const searchQuery = typeof query === 'string' ? query : this.currentSearchQuery

        // Lưu query hiện tại để dùng cho load more
        if (page === 1) {
          this.currentSearchQuery = searchQuery || ''
        }

        this.loadingDevices = true
        const limit = 20

        DeviceService.getAllDeviceCanReturn({
          page,
          limit,
          serial: searchQuery ? searchQuery.trim() : '',
        })
          .then(res => {
            if (res.code === 1000) {
              const devices = res.data || []
              // Kiểm tra nhiều cách API có thể trả về total
              const total = res.total || res.totalElements || res.totalRecords || res.count || 0

              // Store devices by id for lookup
              devices.forEach(device => {
                this.allDevicesCanReturn[device.id] = device
              })

              const mappedDevices = devices.map(device => ({
                id: device.id,
                text: `${device.serial} - ${device.categoryName}`,
              }))

              if (page === 1) {
                this.devicesCanReturnData = mappedDevices
                this.currentPage = 1
              } else {
                // Append for load more - lọc bỏ duplicate dựa trên id
                const existingIds = new Set(this.devicesCanReturnData.map(d => d.id))
                const newDevices = mappedDevices.filter(d => !existingIds.has(d.id))
                this.devicesCanReturnData = [...this.devicesCanReturnData, ...newDevices]
                this.currentPage = page
              }

              this.totalDevices = total

              // Nếu không có total từ API, giả định có thêm data nếu nhận đủ limit items
              if (total === 0 && devices.length === limit) {
                this.hasMoreDevices = true
              } else {
                this.hasMoreDevices = this.devicesCanReturnData.length < total
              }
            } else {
              if (page === 1) {
                this.devicesCanReturnData = []
              }
              this.hasMoreDevices = false
            }
          })
          .catch(error => {
            console.log(error)
            if (page === 1) {
              this.devicesCanReturnData = []
            }
            this.hasMoreDevices = false
          })
          .finally(() => {
            this.loadingDevices = false
            if (callback) callback()
          })
      },

      handleLoadMoreDevices(page) {
        // Gọi lại searchDevices với page mới và query hiện tại
        if (this.currentSearchQuery) {
          this.searchDevices(this.currentSearchQuery, page)
        }
      },

      onDeviceSelected(deviceId, option) {
        const selectedDevice = this.allDevicesCanReturn[deviceId]
        if (selectedDevice) {
          this.device = {
            ...this.device,
            serial: selectedDevice.serial,
          }
        }
      },

      openEditDevice(device, index) {
        this.device = cloneDeep(device)
        this.deviceIndex = index

        // Add current device to options for display when editing
        if (device.serial) {
          this.devicesCanReturnData = [
            {
              id: device.serial,
              text: device.serial,
            },
          ]
        }

        this.$nextTick(s => {
          this.modalEditDeviceStatus = 'edit'
          this.modalEditDevice = true
        })
      },
      openAddDevice() {
        this.device = {}
        this.devicesCanReturnData = []
        this.modalEditDeviceStatus = 'add'
        this.modalEditDevice = true
      },
      deleteDevice(index) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá thiết bị trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.orderDevices.splice(index, 1)
            }
          })
      },
      deleteDeviceMul() {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá những thiết bị đã được chọn trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.orderDevices = differenceBy(
                this.dataAdd.orderDevices,
                this.selected,
                'id'
              )
              this.selected = []
            }
          })
      },
      async requestDevice() {
        if (await this.$refs.deviceRef.validate()) {
          if (this.modalEditDeviceStatus === 'add') {
            this.dataAdd.orderDevices.push({ ...this.device, id: uuidv4() })
          } else {
            this.dataAdd.orderDevices[this.deviceIndex] = this.device
          }
          this.modalEditDevice = false
        }
      },

      async downloadFileTemplate() {
        try {
          this.loading = true
          await DeviceService.downloadFileTemplateReturnRequest()
        } catch (error) {
          this.showErr('Không thể tải file mẫu')
          console.log(error)
        } finally {
          this.loading = false
        }
      },

      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return

        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFormat = allowedExtensions.exec(file.target.files[0].name)

        if (!checkFormat) {
          this.showErr('Định dạng file không hợp lệ! Chỉ chấp nhận .xls, .xlsx, .csv, .ods')
          this.$refs.uploadFileExcel.value = null
          return
        }

        const formdata = new FormData()
        formdata.append('file', file.target.files[0])

        try {
          this.loading = true
          const res = await DeviceService.readFileReturnRequest(formdata)

          if (res.code === 1000) {
            if (res.data.correctList && res.data.correctList.length > 0) {
              this.dataAdd.orderDevices = res.data.correctList.map(s => ({
                ...s,
                id: uuidv4(),
              }))
            }

            this.showImportResult(res.data)
          } else if (res.code === 1020 || res.code === 1007) {
            this.showErr(
              'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
            )
          } else if (res.code === 1021 || res.code === 1040) {
            this.showErr(res.message || 'Có lỗi xảy ra khi đọc file')
          } else {
            this.showErr(res.message || 'Có lỗi xảy ra khi đọc file')
          }
        } catch (e) {
          this.showErr(
            'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
          )
          console.log(e)
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.loading = false
        }
      },

      showImportResult(data) {
        const h = this.$createElement
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Kết quả nhập file' },
        })

        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công: ',
            h('b', { class: ['text-success'] }, data.correctList ? data.correctList.length : 0),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại: ',
            h('b', { class: ['text-danger'] }, data.errorList ? data.errorList.length : 0),
            ' bản ghi',
          ]),
          data.errorList &&
            data.errorList.length > 0 &&
            h(
              'button',
              {
                class: ['btn btn-outline-danger btn-sm mt-2'],
                on: {
                  click: () => this.downloadFileError(data.errorList),
                },
              },
              'Tải danh sách lỗi'
            ),
        ])

        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
          okTitle: 'Đóng',
        })
      },

      async downloadFileError(errorList) {
        try {
          this.loading = true
          await DeviceService.downloadFileErrorReturnRequest(errorList)
        } catch (error) {
          this.showErr('Không thể tải file lỗi')
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }

  .form-control-label {
    display: flex !important;
    align-items: center !important;
  }
</style>
